module.exports = __webpack_public_path__ + "img/zoz2-logo-invert-small-300.055c3aa7.png";